import { render } from "./ActualizarCollegiates1.vue?vue&type=template&id=25179a16"
import script from "./ActualizarCollegiates1.vue?vue&type=script&lang=js"
export * from "./ActualizarCollegiates1.vue?vue&type=script&lang=js"

import "./ActualizarCollegiates1.vue?vue&type=style&index=0&id=25179a16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__